import { SwipeableReviewCard } from 'app/components/swipeable-review-card';
import { View } from 'react-native';
import { styles } from '../components';
import { SwipeTutorialFace, swipeTutorialStyles } from './tutorial-face';

import type { OfferHubState } from '../hooks';

export function OfferHubTutorial({
  swipeTutorialStep,
  swipeTutorialCard,
  t,
  tab,
  focused,
  setSwipeTutorialStep,
  currentItem,
}: Pick<
  OfferHubState,
  'swipeTutorialStep' | 'swipeTutorialCard' | 't' | 'tab' | 'focused' | 'setSwipeTutorialStep' | 'currentItem'
>) {
  return (
    <View style={styles.flex}>
      {swipeTutorialStep < 3 ? (
        <View
          testID="offer-hub-swipe-tutorial-next"
          pointerEvents="none"
          accessibilityElementsHidden
          aria-hidden
          importantForAccessibility="no-hide-descendants"
          style={swipeTutorialStyles.nextCard}
        >
          <SwipeTutorialFace
            key={`swipe-tutorial-next-${String(swipeTutorialStep + 1)}`}
            step={swipeTutorialStep + 1}
          />
        </View>
      ) : null}
      <SwipeableReviewCard
        ref={swipeTutorialCard}
        resetKey={`swipe-tutorial-${String(swipeTutorialStep)}`}
        acceptLabel={t('accept')}
        rejectLabel={t('reject')}
        canAccept={swipeTutorialStep === 1}
        canReject={swipeTutorialStep === 2}
        disabled={swipeTutorialStep === 0 || swipeTutorialStep === 3 || tab !== 'suggestions' || !focused}
        showOverlays={false}
        onAccept={() => setSwipeTutorialStep(2)}
        onReject={() => setSwipeTutorialStep(3)}
        style={[
          styles.flex,
          swipeTutorialStyles.foregroundCard,
          { padding: 0, backgroundColor: 'transparent', shadowOpacity: 0, elevation: 0 },
        ]}
      >
        <SwipeTutorialFace
          step={swipeTutorialStep}
          stackImage={swipeTutorialStep === 3 ? (currentItem?.listingGroup.picture ?? undefined) : undefined}
        />
      </SwipeableReviewCard>
    </View>
  );
}
